import React, { useEffect, useState } from "react";
import { BellRing, X, Plus } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export function AlertEmails({ endpoint = "/portal-settings", title = "E-mails de alerta do sistema", description, testid = "alert-emails" }) {
  const { isAdmin } = useAuth();
  const [emails, setEmails] = useState([]);
  const [draft, setDraft] = useState("");
  useEffect(() => { api.get(endpoint).then(({ data }) => setEmails(data.emails)).catch(() => {}); }, [endpoint]);
  const persist = async (list) => {
    try {
      const { data } = await api.put(endpoint, { emails: list });
      setEmails(data.emails); toast.success("E-mails de alerta atualizados");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  const add = () => {
    const v = draft.trim().toLowerCase();
    if (!/^\S+@\S+\.\S+$/.test(v)) { toast.error("Digite um e-mail válido"); return; }
    if (emails.includes(v)) { toast.error("Este e-mail já está na lista"); return; }
    setDraft(""); persist([...emails, v]);
  };
  return (
    <div className="rounded-xl border border-[#E2E8F0] bg-white p-5 shadow-sm" data-testid={testid}>
      <h3 className="mb-1 flex items-center gap-2 text-base font-semibold text-[#134074]"><BellRing className="h-4 w-4 text-amber-500" /> {title}</h3>
      <p className="mb-4 text-xs text-slate-400">{description || "Recebem os avisos de ASO (vencidos de hora em hora em horário comercial e a vencer em 60/30/7 dias) e de integrações dos Portais. Os administradores do sistema também recebem."}</p>
      <div className="flex flex-wrap gap-2" data-testid="alert-email-list">
        {emails.map((e) => (
          <span key={e} className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-sm text-slate-700" data-testid={`alert-email-${e}`}>
            {e}
            {isAdmin && <button type="button" onClick={() => persist(emails.filter((x) => x !== e))} className="text-slate-400 hover:text-rose-600" title="Excluir" data-testid={`alert-email-remove-${e}`}><X className="h-3.5 w-3.5" /></button>}
          </span>
        ))}
        {!emails.length && <span className="text-xs text-slate-500">Nenhum e-mail cadastrado.</span>}
      </div>
      {isAdmin && (
        <div className="mt-4 flex flex-col gap-2 sm:flex-row">
          <Input value={draft} onChange={(e) => setDraft(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="novo.email@empresa.com.br" data-testid="alert-email-input" />
          <Button onClick={add} className="bg-[#0B2545] hover:bg-[#134074]" data-testid="alert-email-add"><Plus className="mr-1.5 h-4 w-4" /> Adicionar</Button>
        </div>
      )}
    </div>
  );
}
